import React from 'react'

import { styled } from '../../theme'
import { AlertTitle, BaseAlert, BaseAlertProps } from '../BaseAlert'

const StyledAlert = styled(BaseAlert)<{ squared?: boolean }>`
  border-radius: ${({ squared }) => (squared ? 0 : undefined)};
`

export type BannerProps = Pick<BaseAlertProps, 'severity' | 'variant'> & {
  title?: string
  message: string
  squared?: boolean
}

export const Banner = ({ title, message, ...props }: BannerProps) => {
  return (
    <StyledAlert {...props}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </StyledAlert>
  )
}
